import shopData from '../../api/shops';
import * as types from '../mutation-types';
import { EventBus } from '../../api/eventbus';
import BigNumber from 'bignumber.js';
import store from '../index';
import Shop from '../../classes/shop';

/* eslint-disable indent */
const stateData = {
          all:      [],
          progress: []
      },
      getters   = {
          allShops: s => s.all,
          progress: s => s.progress
      },
      actions   = {
          getAllShops({ commit }) {
              shopData.getShops(shops => {
                  commit(types.RECEIVE_SHOPS, { shops });
              });
          },
          setMaxAmount({ commit }, newIncrement) {
              if (stateData.all.length === 0) {
                  // strict mode work-around
                  stateData.all = this.state.shops.all;
              }
              stateData.all.forEach(shop => {
                  let inc = newIncrement > 0
                      ? newIncrement
                      : shop.getMaxAffordableAmount(store.state.game.balance);
                  commit(types.SET_MAX_AMOUNT, { shop, amount: inc });
              });
          }
      },
      mutations = {
          [types.RECEIVE_SHOPS](state, { shops }) {
              if (state.all.length > 0 && !(state.all[0] instanceof Shop)) {
                  state.all.forEach(loaded => {
                      let match = shops.find(s => s.id === loaded.id);
                      if (typeof match !== 'undefined') {
                          match.merge(loaded);
                      }
                  });
              }
              state.all = shops;
          },
          [types.INCREMENT_AMOUNT](state, { shop, amount }) {
              state.all.find(p => p === shop).amount += amount;
          },
          [types.BUILD_BRANCHES](state, { shop, amount }) {
              state.all.find(p => p === shop).buildBranch(amount);
          },
          [types.PRODUCE](state, { shop }) {
              state.all.find(p => p === shop).produce();
          },
          [types.CALCULATE_EARNINGS](state, { shop }) {
              let s = state.all.find(p => p === shop);
              return s.calculateEarnings(s.amount);
          },
          [types.SET_MAX_AMOUNT](state, { shop, amount }) {
              let s = state.all.find(p => p === shop);
              s.maxAmount = amount;
              s.recalculateCosts();
          },
          [types.UPDATE_PRODUCTION_PROGRESS](state, { secondsElapsed, currentQueueEntry }) {
              currentQueueEntry.shop.productionProgress = Math.floor(secondsElapsed / currentQueueEntry.productionTime * 100);
              currentQueueEntry.shop.productionTimeRemaining = (currentQueueEntry.productionTime - secondsElapsed) / 1000;
          },
          [types.UPDATE_PRODUCTION_PROGRESSES](state, queue) {
              state.progress = queue;
          },
          [types.SET_MANAGER](state, { shop, manager }) {
              let s = state.all.find(p => p === shop);
              s.hasManager = true;
              s.manager = manager;
          },
          [types.MODIFY_SHOP_ATTRIBUTE](state, { shop, attribute, value }) {
              let s = state.all.find(p => p === shop);
              s[attribute] = value;
          },
          [types.CALCULATE_INCOME_WHILE_GONE](state, { secondsForProduction }) {
              let incomeGeneratedWhenGone = new BigNumber('0'),
                  income                  = 0;
              state.all.forEach(shop => {
                  income = shop.getIncomeForElapsedTime(secondsForProduction);
                  incomeGeneratedWhenGone = incomeGeneratedWhenGone.plus(income);
              });
              if (incomeGeneratedWhenGone > 0) {
                  store.commit('INCREASE_BALANCE', { amount: incomeGeneratedWhenGone });
              }
              if (secondsForProduction > 0) {
                  EventBus.$emit('addLoadSuccessMessage', secondsForProduction, incomeGeneratedWhenGone);
              }
          },
          [types.FINISH_PRODUCTION](state, { currentQueueEntry, now }) {
              const shop = state.all.find(p => p.id === currentQueueEntry.shop.id);
              shop.productionProgress = 0;
              shop.isProducing = false;
              if (!shop.hasManager) {
                  // production is finished. set progress to 100 and collect in next cycle
                  shop.productionProgress = 100;
                  currentQueueEntry.finished = true;
                  shop.disableProduceButton = false;
              } else {
                  currentQueueEntry.productionTime = shop.coolDown * 1000; //ms
                  // try to avoid too short timeouts. combine them so that no balance update should occur in under 500ms
                  if (currentQueueEntry.productionTime <= 500) {
                      shop.internalFactor = 1000 / currentQueueEntry.productionTime;
                      currentQueueEntry.productionTime *= currentQueueEntry.shop.internalFactor;
                      currentQueueEntry.doUpdate = false;
                      shop.doProgressUpdates = false;
                      shop.productionProgress = 100;
                  }
                  currentQueueEntry.start = now;
              }
          }
      };

export default {
    state: stateData,
    getters,
    actions,
    mutations
};
